import * as fromDatatype from '../../../../models/datatype-library';
export class CmsWebsiteUserAgreementConsentHistoryModifiedContainer {
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    username: fromDatatype.VarcharArrayDatatypeInterface;
    user_email: fromDatatype.VarcharArrayDatatypeInterface;
    user_phone: fromDatatype.VarcharArrayDatatypeInterface;
    user_agr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_type: fromDatatype.VarcharArrayDatatypeInterface;
    consent_method: fromDatatype.VarcharArrayDatatypeInterface;
    ip_address: fromDatatype.VarcharArrayDatatypeInterface;
    browser_agent: fromDatatype.VarcharArrayDatatypeInterface;
    esignature: fromDatatype.VarcharArrayDatatypeInterface;
    cookies: fromDatatype.VarcharArrayDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}